import { render, staticRenderFns } from "./AboutView.vue?vue&type=template&id=73e3d9c7&"
import script from "./AboutView.vue?vue&type=script&lang=ts&"
export * from "./AboutView.vue?vue&type=script&lang=ts&"
import style0 from "./AboutView.vue?vue&type=style&index=0&id=73e3d9c7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports